module.exports = __webpack_public_path__ + "img/1-5.6af05104.svg";